<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" >
      <b-col md="11" lg="9" xl="5">
        <b-card>
          <div slot="header">{{$route.meta.label}}
            <div class="card-header-actions">
              <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="print()">
                <i class="fa fa-print"></i> Print
              </button>
              <b-button class="btn btn-danger mr-1" @click="close()">
                <i class="fa fa-close"></i> Batal
              </b-button>
            </div>
          </div>

            <b-input-group>
              <b-input-group-prepend>
                <label>Tanggal Kirim</label>
              </b-input-group-prepend>
              <b-form-input v-model="model.tanggal" type="date" :state="!$v.model.tanggal.$error"></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Agen / Customer</label>
              </b-input-group-prepend>
              <b-form-input v-model="customer_info" placeholder="kode | nama agen." readonly></b-form-input>
              <b-input-group-append>
                <b-btn
                  text="Button"
                  id="btnKoranCust"
                  @click="lkuKoranCustShow=true"
                  variant="primary"
                >
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
              <b-input-group-append>
                <b-btn text="Button" @click="clearCust">
                  <i class="fa fa-close"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Jurusan</label>
              </b-input-group-prepend>
              <b-form-input v-model="jurusan_info" placeholder="Kode | nama jurusan." readonly></b-form-input>
              <b-input-group-append>
                <b-btn
                  text="Button"
                  id="btnKoranJurusan"
                  @click="lkuKoranJurusanShow=true"
                  variant="primary"
                >
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
              <b-input-group-append>
                <b-btn text="Button"  @click="clearJurusan">
                  <i class="fa fa-close"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
            <div class="float-right">
              <button class="btn btn-warning mr-1 float-right" @click.stop="clear()">
                <i class="fa fa-close"></i> Clear All
              </button>
            </div>
      <!-- <b-row class="justify-content-center mb-2">
        <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="print()">
          <i class="fa fa-print"></i> Print
        </button>
        <b-button class="btn btn-primary mr-1" @click.stop="close()">
          <i class="fa fa-close"></i> Batal
        </b-button>
      </b-row> -->

        </b-card>
      </b-col>
    </b-row>

    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>


    <b-modal
      v-model="lkuKoranCustShow"
      size="lg"
      :hide-footer="true"
      title="List of Agen/Langganan"
      :centered="true"
    >
      <lku-customerkoran @click="onSelectKoranCust"></lku-customerkoran>
    </b-modal>
    <b-modal
      v-model="lkuKoranJurusanShow"
      size="lg"
      :hide-footer="true"
      title="List Jurusan Koran"
      :centered="true"
    >
      <lku-jurusan @click="onSelectKoranJurusan"></lku-jurusan>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>



<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
import Loading from "vue-loading-overlay";
import koran_report from "../../apis/koran_report";
import lkuCustomerkoran from "../lookup/lkuKoranCust";
import lkuJurusan from "../lookup/lkuKoranJurusan";
toastr.init();

export default {
  components: { Loading, lkuCustomerkoran, lkuJurusan },
  mixins: [validationMixin],
  validations: {
    model: {
      tanggal: { required },
      jurusanId: {
        required: true,
        minLength: minLength(1),
        $each: {
          required
        }
      }
    }
  },
  data() {
    return {
      isLoading: false,
      horizontal: true,
      saveEnabled: true,
      lkuKoranCustShow: false,
      lkuKoranJurusanShow: false,
      model: {
        tanggal: null,
        customer_id: null,
        jurusan_id: null
      },
      showReport: false,
      reportUrl: null,
      customer_info: null,
      jurusan_info: null
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    }
  },
  watch: {},
  created: async function() {},
  methods: {
    onSelectKoranCust(_selected) {
      this.customer_info = `${_selected.CustCode + " | " + _selected.CustName}`;
      this.model.customer_id = _selected.customer_id;
      this.lkuKoranCustShow = false;
    },
    onSelectKoranJurusan(_selected) {
      this.jurusan_info = `${_selected.jurusan_code +
        " | " +
        _selected.jurusan_name}`;
      this.model.jurusan_id = _selected.jurusan_id;
      this.lkuKoranJurusanShow = false;
    },
    print: async function() {
      if (this.invalidModel) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
        this.reportUrl=null; this.showReport = true;
          this.reportUrl = await koran_report.suratJalanMIPrint(this.model);
          this.isLoading = false;
        } catch (error) {
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    clearCust() {
      this.model.cutomer_id = null;
      this.customer_info = null;
    },
    clearJurusan() {
      this.model.jurusan_id = null;
      this.jurusan_info = null;
    },
    clear: function() {
      this.clearCust;
      this.clearJurusan;
    },
    close() {
      if (this.$store.state.prevRoute.name) {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        router.push({ name: "koran.home" });
      }
    }
  }
};
</script>